import { render, staticRenderFns } from "./uploadContract.vue?vue&type=template&id=48b23412&scoped=true&"
import script from "./uploadContract.vue?vue&type=script&lang=js&"
export * from "./uploadContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b23412",
  null
  
)

export default component.exports